var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c(
        "div",
        { staticClass: "e-skeleton" },
        _vm._l(_vm.widths.length, function (n) {
          return _c("div", {
            key: n,
            staticClass: "e-skeleton__line",
            style: { width: _vm.getWidth(n - 1), height: _vm.lineHeight },
          })
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }